export const paths = {
  HOME: "/",
  PAYMENT_BATCHES: "/payment-batches",
  PAYMENT_BATCH_ORDERS: "/payment-batches/:id/orders",
  SIM_BANK: "/sim-bank",
  SELLERS_BALANCES: "/sellers-balances",
  SELLER_STATEMENT: "/seller-statement",
  AUTO_WITHDRAW: "/auto-withdraw",
  SIGN_IN: "/sign-in",
  RECOVER_PASSWORD: "/recover-password",
  RESET_PASSWORD: "/reset-password",
} as const;
